import { Progress } from '@e2n/ui';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faGraduationCap, faStar } from '@fortawesome/pro-regular-svg-icons';
import {
  faStar as faStarFilled,
  faStarHalfStroke,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function RotationsplanProgress({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const percentage =
    (rotationsplan.abgeschlosseneStationen.length * 100) /
    rotationsplan.amountOfStationen;

  const alleStationen = rotationsplan.allStationen;

  const firstStation = alleStationen[0];
  const lastStation = alleStationen[alleStationen.length - 1];
  const bewertungCount = rotationsplan.bewertungenMitSternen.length;
  const averageBewertungScore = rotationsplan.getAverageBewertungScore();

  return (
    <div className="flex sm:flex-row sm:justify-between sm:items-center sm:gap-4 flex-col items-start">
      <div className="flex items-center gap-2 w-full md:w-1/2">
        <Progress value={percentage} className=" bg-neutrals-300 h-2" />
        <div className="hidden md:flex text-sm text-neutrals-800 whitespace-nowrap">
          {alleStationen.length > 0
            ? t('domain.mitarbeiter.rotationsplan.rotationsplaene.progress', {
                abgeschlossen: rotationsplan.abgeschlosseneStationen.length,
                alleStationen: alleStationen.length,
              })
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </div>
        <div className="flex md:hidden text-sm text-neutrals-800 whitespace-nowrap">
          {alleStationen.length > 0
            ? `${rotationsplan.abgeschlosseneStationen.length} / ${rotationsplan.amountOfStationen}`
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </div>
      </div>
      {alleStationen.length > 0 && (
        <div className="flex items-center justify-between sm:gap-4 sm:w-auto w-full text-neutrals-800 text-sm whitespace-nowrap">
          {bewertungCount > 0 && (
            <div className="flex items-center gap-1">
              {averageBewertungScore.toLocaleString('de-DE', {
                maximumFractionDigits: 1,
              })}
              {[1, 2, 3, 4, 5].map((value) => (
                <FontAwesomeIcon
                  icon={
                    averageBewertungScore >= value
                      ? faStarFilled
                      : averageBewertungScore >= value - 0.5
                        ? faStarHalfStroke
                        : faStar
                  }
                />
              ))}
              ({bewertungCount})
            </div>
          )}
          <div className="flex items-center gap-1 ">
            <FontAwesomeIcon icon={faGraduationCap} />
            {`${dayjs(firstStation.von).format('MMM YYYY')} – ${dayjs(lastStation.bis).format('MMM YYYY')}`}
          </div>
        </div>
      )}
    </div>
  );
}
